import {
  faCalendarDays,
  faClock,
  faUmbrellaBeach,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Title } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useSendQuestion } from '../hooks/useSendQuestion';
import { useAIAuth } from '../lib/AIAuthContext';

// Platzhalter-Fragen
const SUGGESTIONS = [
  { key: 'dienstplan', icon: faCalendarDays },
  { key: 'abwesenheit', icon: faUmbrellaBeach },
  { key: 'arbeitszeiten', icon: faClock },
] as const;

export function ChatEmptyState() {
  const { t } = useTranslation();
  const { user } = useAIAuth();
  const sendQuestion = useSendQuestion();

  return (
    <div className="mt-auto flex flex-col gap-3 pb-4">
      <Title className="whitespace-pre-line">
        {user?.firstName
          ? t('domain.ai.chat.greeting', { name: user.firstName })
          : t('domain.ai.chat.greetingWithoutName')}
      </Title>
      {SUGGESTIONS.map(({ key, icon }) => {
        const question = t(`domain.ai.chat.suggestions.${key}`);
        return (
          <Button
            key={key}
            variant="secondary-blue"
            onClick={() => sendQuestion(question)}
            className="h-10 w-full justify-start gap-1.5 rounded-lg px-2">
            <FontAwesomeIcon icon={icon} className="size-5" />
            <span className="truncate">{question}</span>
          </Button>
        );
      })}
    </div>
  );
}
